module.exports = __webpack_public_path__ + "img/rental-cost.6ff8892b.svg";